<ng-template #popContent>
	@for (item of _content; track $index) {
		<div class="popover-content">
			<div class="popover-content-label {{labelClassName}}" [class.text-center]="centerText" [translate]="item.label" [translateParams]="item.labelParams"></div>
			<div [ngClass]="fontSizeClassName(translateValue ? (item.value | translate) : item.value)" [class.text-center]="centerText">{{ translateValue ? (item.value | translate: item.valueParams) : item.value }}</div>
		</div>
	}
</ng-template>

<button type="button"
	class="{{ btnClass }} btn-reset si info-icon far ml-1 {{ icon }}"
	[triggers]="triggers"
	(click)="onButtonClicked($event, popover)"
	[autoClose]="true"
	[ngbPopover]="popContent"
	[disabled]="disabled"
	(shown)="shown.emit()"
	(hidden)="hidden.emit()"
	#popover="ngbPopover"
	placement="top"
	container="body">
		<span class="popover-content-button-text">
			<ng-content/>
		</span>
</button>
